
import { Component, Vue } from 'vue-property-decorator'

import { CardList } from '@/types/Card'
import cardModule from '@/store/card'

import CardListComponent from '@/components/company/card/CardList.vue'
import CardListEditor from '@/components/company/cardList/CardListEditor.vue'
import ContentList from '@/components/listView/ContentList.vue'
import { ListType, DefaultCardList } from '@/utils/enums'

@Component({
  name: 'CardListList',
  components: {
    CardListComponent,
    CardListEditor,
    ContentList
  }
})
class CardListList extends Vue {
  private listType = ListType

  private get storeModule() {
    return cardModule
  }

  private get featuredList() {
    return cardModule.featuredList
  }

  private get cardLists(): CardList[] {
    return cardModule.cardLists.filter(el => el.name !== DefaultCardList.NAME)
  }

  private get allLists(): CardList[] {
    return this.featuredList!.concat(
      this.cardLists.sort((a, b) => a.index - b.index)
    )
  }

  private get headers() {
    return [
      { text: '', value: 'handle', sortable: false },
      { text: 'Name', value: 'name', sortable: false },
      { text: 'Status', value: 'active', sortable: false }
    ]
  }

  private async created() {
    await cardModule.fetchFeaturedList()
  }

  private setCardList(cardList: CardList): void {
    cardModule.setCardList(cardList)
    this.$router.push({ name: 'CardListDetail', params: { cid: cardList._id } })
  }
}

export default CardListList
